import CustomTooltip from "app/components/Tooltip";
import CommonTargetRelease from "app/containers/Features/components/CommonRelease";
import React from "react";
import { releasesData } from "../../../../components/CreateBoardsComponent/data";

interface CustomProps {
  value: string;
}
const TargetRelease: React.FC<CustomProps> = ({ value }) => {
  //
  const selectedOptions =
    releasesData.find((p) => p.id === value) || releasesData[0];

  return (
    <>
      <CommonTargetRelease
        trigger={
          <button className="flex items-center justify-start hover:border hover:border-[#BDC0C3] p-[4px] rounded-[2px] min-w-[109px] cursor-pointer ">
            <CustomTooltip
              text="Set release"
              className="flex items-center "
              position="left"
            >
              <div className="flex items-center gap-2 w-full">
                <span className="text-sm font-normal text-black">
                  {selectedOptions.label}
                </span>
              </div>
            </CustomTooltip>
          </button>
        }
        isHeader="releases"
        data={releasesData}
      />
    </>
  );
};

export default TargetRelease;
